import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function SCHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1848">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/41agAsvvAKgGK67o21ELBG/Sculptra.jpg)'
    }} data-id="element-1849" />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" data-id="element-1850" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1851">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-1852">
          <div className="mb-6" data-id="element-1853">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1854">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1855">
                Treatments
              </a>{' '}
              / Injectables
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1856">
            Be BOLD
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1857">
            SCULPTRA
          </h1>

          <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1858">
            Among our transformative aesthetic treatments, Sculptra stands out
            as an effective dermal filler for lasting rejuvenation. The
            experienced team at Be CLINICAL understands the intricacies of
            Sculptra and its remarkable ability to stimulate collagen
            production, allowing us to address a wide range of concerns for our
            clients, from facial volume loss to wrinkles to contouring.
          </p>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1859">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}